import { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core';
import { eadmissionAPI } from '../../../../../apis';
import AdmissionLocationViewSetting from '../../../../Admission/components/AdmissionLocationViewSetting';
import {
  buildLocationSettingCubicleParams,
  revampLocationSettingCubicle,
} from '../../../../Admission/components/AdmissionLocationViewSetting/utils';
import EAdmissionToolbar from '../../../../Admission/components/EADViewFloorPlan/components/EAdmissionToolbar';
import { BS_TOOLBAR_STATUS } from '../../../../../comm/constant';

const useStyles = makeStyles(() => ({
  toolbar: {
    position: 'absolute',
    left: '-3.438rem',
  },
}));

export default function AEDViewSetting() {
  const classes = useStyles();
  const [enableAEDView, setEnableAEDView] = useState(false);
  const [cubicleList, setCubicleList] = useState([]);
  const [AEDVersion, setAEDVersion] = useState(null);
  const [toolStatus, setToolStatus] = useState({ type: BS_TOOLBAR_STATUS.MOVE, zoom: 1, reset: 0 });
  const [showCreateCubiclePop, setShowCreateCubiclePop] = useState(false);

  const handleReset = async () => {
    await getAEDCubicles();
    await getAEDViewSetting();
  };

  const handleUpdate = async (nextCubicleList) => {
    try {
      const params = {
        cubicles: _.map(nextCubicleList, (item) => buildLocationSettingCubicleParams(item)),
        version: AEDVersion,
      };
      await eadmissionAPI.updateAEDCubicleList(params);
      await getAEDCubicles();
    } catch (error) {}
  };

  const getAEDCubicles = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getAEDSettingCubicleList();
      setAEDVersion(result?.version);
      const newCubList = _.map(result?.cubicles, (item) => revampLocationSettingCubicle(item));
      setCubicleList(newCubList);
    } catch (error) {}
  }, []);

  const getAEDViewSetting = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getAEDViewVisible();
      setEnableAEDView(result?.visible === 1);
    } catch (error) {}
  }, []);

  const updateAEDViewSetting = useCallback(async (isChecked) => {
    try {
      const { statusCode } = await eadmissionAPI.updateAEDViewVisible({ visible: isChecked ? 1 : 0 });
      if (statusCode === '0') {
        getAEDViewSetting();
      }
    } catch (error) {}
  }, []);

  useEffect(() => {
    getAEDCubicles();
    getAEDViewSetting();
  }, []);

  return (
    <>
      <EAdmissionToolbar
        type="edit"
        status={toolStatus}
        setStatus={setToolStatus}
        handleShowPopup={() => setShowCreateCubiclePop(true)}
        className={classes.toolbar}
      />
      <AdmissionLocationViewSetting
        enableView={enableAEDView}
        label="AED location view"
        toolStatus={toolStatus}
        setToolStatus={setToolStatus}
        showCreateCubiclePop={showCreateCubiclePop}
        setShowCreateCubiclePop={setShowCreateCubiclePop}
        cubicleList={cubicleList}
        setCubicleList={setCubicleList}
        updateViewSetting={updateAEDViewSetting}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        viewType="AED"
      />
    </>
  );
}
